<template>
    <v-tabs v-model="mobileTabs" fixed-tabs class="mobile-info-tabs sticky-bar">
        <v-tab>{{ $t('info') }}</v-tab>
        <v-tab>{{ $t(mobileTab1Title) }}</v-tab>
    </v-tabs>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue, Watch} from 'vue-facing-decorator'

    @Component
    export class MobileInfoPageTabs extends Vue {
        @VModel({default: 0}) mobileTabs
        @Prop({default: 'offers'}) mobileTab1Title

        @Watch('mobileTabs')
        onChangeMobileTabs(val) {
            this.$emit('change', val)
        }
    }

    export default MobileInfoPageTabs
</script>
